import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '../../contexts';

const useStyles = (centered: boolean, hasActions: boolean) => {
    const theme = useWolfTheme();

    return useMemo(
        () => ({
            headingWrapper: css({
                display: 'flex',
                justifyContent: hasActions ? 'space-between' : 'stretch',
                alignItems: 'center',
            }),
            heading: css({
                textAlign: centered ? 'center' : 'left',
                color: theme.palette.foreground.default,
                flexGrow: 1,
            }),

            subheading: css({
                fontSize: theme.typography.size5,
                marginTop: theme.orbitalThree,
                textAlign: centered ? 'center' : 'left',
            }),

            logo: css({
                display: 'flex',
                justifyContent: 'center',
            }),
        }),
        [hasActions, centered, theme.palette.foreground.default, theme.typography.size5, theme.orbitalThree]
    );
};

export default useStyles;
